import moment from 'moment'

export default {
    name: 'DateSelect',
    props: {
      value: {
        type: Array,
        default: () => ['', ''], // 默认值为空数组
      },
      prefixLabel: {
        type: String,
        default: '日期范围' // 默认前缀标签
      },
      startPlaceholder: {
        type: String,
        default: '请选择开始日期' // 默认开始日期占位符
      },
      endPlaceholder: {
        type: String,
        default: '请选择结束日期' // 默认结束日期占位符
      }
    },
    data() {
      return {
        internalDate: [...this.value], // 深拷贝父组件传递的 value
        shortcutsR: [
          {
            text: '今天',
            onClick: () => {
              const today = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
              this.updateDate(today);
            },
          },
          {
            text: '昨天',
            onClick: () => {
              const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
              this.updateDate([yesterday, yesterday]);
            },
          },
          {
            text: '最近3天',
            onClick: () => {
              const recent3Days = [moment().subtract(3, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
              this.updateDate(recent3Days);
            },
          },
          {
            text: '最近5天',
            onClick: () => {
              const recent5Days = [moment().subtract(5, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
              this.updateDate(recent5Days);
            },
          },
          {
            text: '最近7天',
            onClick: () => {
              const recent7Days = [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
              this.updateDate(recent7Days);
            },
          },
          {
            text: '最近14天',
            onClick: () => {
              const recent14Days = [moment().subtract(14, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
              this.updateDate(recent14Days);
            },
          },
          {
            text: '最近1个月',
            onClick: () => {
              const recent1Month = [moment().subtract(1, 'months').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
              this.updateDate(recent1Month);
            },
          },
        ],
      };
    },
    watch: {
      value(newVal) {
        this.internalDate = [...newVal]; // 监听父组件的 value 变化并更新内部值
      }
    },
    methods: {
      updateDate(dateRange) {
        this.internalDate = dateRange;
        this.$emit('input', dateRange); // 通过 input 事件向父组件传递更新后的值
      },
      handleChange () {
        this.$emit('input', this.internalDate); // 监听内部值变化并通过 input 事件向父组件传递更新后的值
      }
    }
  }
